import "./TabLoaderComponent.scss";
import { useEffect, useState } from "react";
import LottieRendererComponent from "@/components/common-components/lottie-renderer/LottieRendererComponent.tsx";
import { ImageConfig } from "@/constants";


const messages = [
    "Preparing Preview for Your Project...",
    "Installing Required Libraries and Dependencies...",
    "Building Your Application...",
    "Configuring Initial Project Settings...",
    "Optimizing for Best Performance...",
    "Setting Up Project Structure...",
    "Finalizing Setup...",
    "Launching Your Application, Almost Ready..."
];

const TabLoaderComponent = (props: { progressMessage: string }) => {

    let { progressMessage } = props;

    //if progress mesage has . in between split and capitalise first letters
    progressMessage = progressMessage.split('.').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setMessageIndex((prevIndex: number) => (prevIndex + 1) % messages.length);
        }, 2000);
        return () => clearInterval(interval);
    }, []);


    return (
        <div className="tab-loader">
            <LottieRendererComponent animationData={ImageConfig.FlashLottie} />
            <div className="status-container">
                {
                    progressMessage ?
                        <span key={messageIndex} className="status-message">
                            {progressMessage}
                        </span>
                        :
                        <span key={messageIndex} className="status-message">
                            {messages[messageIndex]}
                        </span>
                }
            </div>
        </div>
    );

};

export default TabLoaderComponent;
